import { MenuTitleType } from "../components/MenuHeader";
import { MENU_SCREEN } from "../menu.types";

const menuHeading: Record<
  MENU_SCREEN,
  {
    titleWords: MenuTitleType;
    description: string;
  }
> = {
  [MENU_SCREEN.Backpacks]: {
    titleWords: [{ text: "Rucsace", isHighlighted: true }],
    description: "Vizualizează și gestionează rucsacurile tale.",
  },
  [MENU_SCREEN.Jobs]: {
    titleWords: [{ text: "Locuri", isHighlighted: true }, { text: "de muncă" }],
    description: "Găsește și aplică pentru locurile de muncă disponibile.",
  },
  [MENU_SCREEN.Home]: {
    titleWords: [{ text: "Meniu", isHighlighted: true }, { text: "Principal" }],
    description: "Bine ai venit în meniul principal.",
  },
  [MENU_SCREEN.Missions]: {
    titleWords: [{ text: "Misiuni", isHighlighted: true }],
    description: "Vizualizează misiunile active și disponibile.",
  },
  [MENU_SCREEN.MoneyPackages]: {
    titleWords: [{ text: "Pachete", isHighlighted: true }, { text: "de Bani" }],
    description: "Cumpără pachete și îmbunătățește-ți experiența.",
  },
  [MENU_SCREEN.Organizations]: {
    titleWords: [{ text: "Organizații", isHighlighted: true }],
    description: "Gestionează organizația ta sau alătură-te uneia noi.",
  },
  [MENU_SCREEN.Other]: {
    titleWords: [{ text: "Altele", isHighlighted: true }],
    description: "Alte opțiuni și setări diverse.",
  },
  [MENU_SCREEN.Profile]: {
    titleWords: [{ text: "Profil", isHighlighted: true }],
    description: "Vizualizează și editează profilul tău.",
  },
  [MENU_SCREEN.Referral]: {
    titleWords: [{ text: "Referral", isHighlighted: true }],
    description: "Ridică recompensele și bonusurile tale.",
  },
  [MENU_SCREEN.Settings]: {
    titleWords: [{ text: "Setări", isHighlighted: true }],
    description: "Personalizează setările după preferințele tale.",
  },
  [MENU_SCREEN.Shop]: {
    titleWords: [{ text: "Magazin", isHighlighted: true }],
    description: "Cumpără iteme, vehicule și echipamente.",
  },
  [MENU_SCREEN.Vehicles]: {
    titleWords: [{ text: "Vehicule", isHighlighted: true }],
    description: "Gestionează vehiculele și garajul tău.",
  },
  [MENU_SCREEN.Vip]: {
    titleWords: [{ text: "VIP", isHighlighted: true }],
    description: "Beneficii și privilegii exclusive VIP.",
  },
  [MENU_SCREEN.Containers]: {
    titleWords: [{ text: "Containere", isHighlighted: true }],
    description: "Deschide containere și câștigă recompense exclusive.",
  },
  [MENU_SCREEN.Rules]: {
    titleWords: [{ text: "Reguli", isHighlighted: true }],
    description: "Regulamentul serverului și sancțiunile aplicate.",
  },
  [MENU_SCREEN.Haine]: {
    titleWords: [{ text: "Haine", isHighlighted: true }],
    description: "Personalizează-ți ținuta și aspectul personajului.",
  },
  [MENU_SCREEN.Animatii]: {
    titleWords: [{ text: "Animații", isHighlighted: true }],
    description: "Achiziționează animații și emote-uri exclusive.",
  },
  [MENU_SCREEN.Wiki]: {
    titleWords: [{ text: "Wiki", isHighlighted: true }],
    description: "Documentația oficială a serverului Atlantis.",
  },
  [MENU_SCREEN.Report]: {
    titleWords: [{ text: "Creeaza" }, { text: "Ticket", isHighlighted: true }],
    description: "Report user.",
  },
  [MENU_SCREEN.Vouchers]: {
    titleWords: [{ text: "Vouchere", isHighlighted: true }],
    description: "Răscumpără vouchere și primește AtlantisPoints în contul tău.",
  },
};

export const getHeadingByScreen = (screen: MENU_SCREEN) => {
  return menuHeading[screen];
};
